import React from 'react';
import WordPressMockupForm from './components/WordPressMockupForm';

function App() {
  return (
    <div>
      <WordPressMockupForm />
    </div>
  );
}

export default App;
